// Check for IntersectionObserver support
if ('IntersectionObserver' in window) {
  document.addEventListener("DOMContentLoaded", function() {

    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Item has crossed our observation
          // threshold - load src from data-src
          entry.target.style.backgroundImage = "url('" + entry.target.dataset.bg + "')";
          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }

    const backgroundImages = document.querySelectorAll('.lazyload-bg');
    const observer = new IntersectionObserver(
      handleIntersection,
      { rootMargin: "100px" }
    );
    backgroundImages.forEach(header => observer.observe(header));
  });
} else {
  // No interaction support? Load all background images automatically
  const backgroundImages = document.querySelectorAll('.lazyload-bg');
  backgroundImages.forEach(elem => {
    elem.style.backgroundImage = "url('" + elem.dataset.bgimage + "')";
  });
}
